function isNonEmptyString(value) {
    return typeof value === 'string' && value.length > 0;
}
export function isValidPinnedThreadItem(item) {
    if (item.kind !== 'thread')
        return false;
    const thread = item.thread;
    return (thread != null &&
        isNonEmptyString(thread.context_uuid) &&
        isNonEmptyString(thread.slug) &&
        isNonEmptyString(thread.uuid));
}
export function getValidPinnedThreadContextUuid(item) {
    if (item.kind !== 'thread')
        return undefined;
    const contextUuid = item.thread?.context_uuid;
    return isNonEmptyString(contextUuid) ? contextUuid : undefined;
}
//# sourceMappingURL=pinnedThreadItem.js.map